import { render, staticRenderFns } from "./320ee06e-a306-4055-a5c0-662d9979f69e.vue?vue&type=template&id=2bc338b5&scoped=true"
import script from "./320ee06e-a306-4055-a5c0-662d9979f69e.vue?vue&type=script&lang=ts"
export * from "./320ee06e-a306-4055-a5c0-662d9979f69e.vue?vue&type=script&lang=ts"
import style0 from "./320ee06e-a306-4055-a5c0-662d9979f69e.vue?vue&type=style&index=0&id=2bc338b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc338b5",
  null
  
)

export default component.exports